// import React, { useState, useEffect } from 'react';
// import { motion } from 'motion/react';
// import { Menu, X, Moon, Sun } from 'lucide-react';
// import { useTheme } from './ThemeProvider';
// import { AuthModal } from './AuthModal';

// interface NavbarProps {
//   onLoginSuccess?: () => void;
// }

// export function Navbar({ onLoginSuccess }: NavbarProps) {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
//   const { theme, toggleTheme } = useTheme();

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const menuItems = ['About Us', 'Pricing', 'Contact'];

//   const handleLoginClick = () => {
//     setIsAuthModalOpen(true);
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <>
//       <motion.nav
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
//           isScrolled
//             ? 'bg-background/80 backdrop-blur-xl shadow-lg border-b border-border'
//             : 'bg-transparent'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
//           <div className="flex items-center justify-between h-16 lg:h-20">
//             {/* Logo */}
//             <motion.div
//               className="flex-shrink-0"
//               whileHover={{ scale: 1.05 }}
//               transition={{ type: 'spring', stiffness: 400 }}
//             >
//               <h1 className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//                 NFC Design Studio
//               </h1>
//             </motion.div>

//             {/* Desktop Menu */}
//             <div className="hidden lg:flex items-center gap-8">
//               {menuItems.map((item, index) => (
//                 <motion.a
//                   key={item}
//                   href={`#${item.toLowerCase().replace(' ', '-')}`}
//                   className="relative text-foreground hover:text-primary transition-colors group"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 + 0.3 }}
//                 >
//                   {item}
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-primary to-accent group-hover:w-full transition-all duration-300" />
//                 </motion.a>
//               ))}
//             </div>

//             {/* Right Actions */}
//             <div className="flex items-center gap-4">
//               {/* Theme Toggle */}
//               <motion.button
//                 onClick={toggleTheme}
//                 className="p-2 rounded-xl bg-card hover:bg-muted transition-colors"
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.95 }}
//                 aria-label="Toggle theme"
//               >
//                 {theme === 'light' ? (
//                   <Moon className="w-5 h-5 text-foreground" />
//                 ) : (
//                   <Sun className="w-5 h-5 text-foreground" />
//                 )}
//               </motion.button>

//               {/* Login Button - Desktop */}
//               <motion.button
//                 onClick={handleLoginClick}
//                 className="hidden lg:block px-6 py-2.5 bg-gradient-to-r from-primary to-accent text-white rounded-xl font-medium shadow-lg hover:shadow-xl hover:shadow-primary/30 transition-all duration-300"
//                 whileHover={{ scale: 1.05, y: -2 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 Login
//               </motion.button>

//               {/* Mobile Menu Toggle */}
//               <button
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//                 className="lg:hidden p-2 rounded-xl bg-card hover:bg-muted transition-colors"
//                 aria-label="Toggle menu"
//               >
//                 {isMobileMenuOpen ? (
//                   <X className="w-6 h-6 text-foreground" />
//                 ) : (
//                   <Menu className="w-6 h-6 text-foreground" />
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMobileMenuOpen && (
//           <motion.div
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: 'auto' }}
//             exit={{ opacity: 0, height: 0 }}
//             className="lg:hidden bg-card/95 backdrop-blur-xl border-t border-border"
//           >
//             <div className="px-4 py-6 space-y-4">
//               {menuItems.map((item) => (
//                 <a
//                   key={item}
//                   href={`#${item.toLowerCase().replace(' ', '-')}`}
//                   className="block py-2 text-foreground hover:text-primary transition-colors"
//                   onClick={() => setIsMobileMenuOpen(false)}
//                 >
//                   {item}
//                 </a>
//               ))}
//               <button
//                 onClick={handleLoginClick}
//                 className="w-full px-6 py-3 bg-gradient-to-r from-primary to-accent text-white rounded-xl font-medium shadow-lg"
//               >
//                 Login
//               </button>
//             </div>
//           </motion.div>
//         )}
//       </motion.nav>

//       {/* Auth Modal */}
//       <AuthModal  isOpen={isAuthModalOpen}  onClose={() => setIsAuthModalOpen(false)}  onLoginSuccess={onLoginSuccess} />
//     </>
//   );
// }




import React, { useState, useEffect } from "react";
import { Menu, X, } from "lucide-react";
import { AuthModal } from "./AuthModal";
import Logo from "../Components/Images/logonobg.png";

const Navbar = ({ onLoginSuccess }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Handle scroll shadow
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Track window width for responsiveness
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleLoginClick = () => {
    setIsAuthModalOpen(true);
    setIsMobileMenuOpen(false);
  };

  const menuItems = ["About Us", "Pricing", "Contact"];

  // Responsive breakpoints
  const isLG = windowWidth >= 1024;
  const isMD = windowWidth >= 768 && windowWidth < 1024;
  const isSM = windowWidth < 768;

  return (
    <>
      <nav style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 50, background: isScrolled ? "rgba(255,255,255,0.85)" : "transparent", backdropFilter: isScrolled ? "blur(12px)" : "none", boxShadow: isScrolled ? "0 4px 20px rgba(0,0,0,0.1)" : "none", transition: "all 0.3s ease", padding: '10px' }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: isSM ? "0 12px" : isMD ? "0 16px" : "0 20px", height: isSM ? "60px" : isMD ? "70px" : "80px", display: "flex", alignItems: "center", justifyContent: "space-between", }}>
          <img src={Logo} alt="NFC Design Studio" style={{ height: isSM ? "50px" : isMD ? "60px" : "80px", objectFit: "contain", cursor: "pointer", }} />
          {isLG && (
            <div style={{ display: "flex", gap: "32px" }}>
              {menuItems.map((item) => (
                <a key={item} href={`#${item.toLowerCase().replace(" ", "-")}`} style={{ textDecoration: "none", color: "#111", fontSize: "16px", position: "relative", }}>
                  {item}
                </a>
              ))}
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {(isLG || isMD) && (
              <button onClick={handleLoginClick} style={{ padding: isSM ? "6px 10px" : isMD ? "8px 12px" : "10px 16px", borderRadius: "10px", border: "none", cursor: "pointer", background: "linear-gradient(to right, #6366f1, #22d3ee)", color: "#fff", fontWeight: "500", }}>Login</button>
            )}
            {(isMD || isSM) && (
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} style={{ padding: "8px", borderRadius: "10px", border: "none", background: "#f1f5f9", cursor: "pointer", display: isLG ? "none" : "block", }}>
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            )}
          </div>
        </div>
        {/* Mobile Menu */}
        {(isMD || isSM) && isMobileMenuOpen && (
          <div style={{ display: "flex", flexDirection: "column", background: "#fff", padding: "20px", borderTop: "1px solid #e5e7eb", }}>
            {menuItems.map((item) => (
              <a key={item} href={`#${item.toLowerCase().replace(" ", "-")}`} style={{ padding: "10px 0", color: "#111", textDecoration: "none", }} onClick={() => setIsMobileMenuOpen(false)}>
                {item}
              </a>
            ))}

            <button onClick={handleLoginClick} style={{ width: "100%", padding: "10px 16px", borderRadius: "10px", border: "none", cursor: "pointer", background: "linear-gradient(to right, #6366f1, #22d3ee)", color: "#fff", fontWeight: "500", marginTop: "12px", }}>
              Login
            </button>
          </div>
        )}
      </nav>

      {/* Auth Modal */}
      <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} onLoginSuccess={onLoginSuccess} />
    </>
  );
};

export default Navbar;

